var map = {
	"./BannerSectionWithCoverImage.js": 8766,
	"./BarPosSystemPage/IncreaseRevenueSection.js": 5708,
	"./BarPosSystemPage/MakeBetterDecisionsSection.js": 950,
	"./BarPosSystemPage/OfferExcellentServiceSection.js": 2290,
	"./BarPosSystemPage/OverviewSection.js": 4261,
	"./BarPosSystemPage/index.js": 1813,
	"./BarPosSystemRedirect.js": 6387,
	"./ClosingSection.js": 8479,
	"./DownloadsPage.js": 5003,
	"./DownloadsRedirect.js": 1816,
	"./FoodTruckPosPage/ImproveServiceSection.js": 3379,
	"./FoodTruckPosPage/IncreaseYourSalesSection.js": 4679,
	"./FoodTruckPosPage/OverviewSection.js": 69,
	"./FoodTruckPosPage/TakeBetterDecisionsSection.js": 3245,
	"./FoodTruckPosPage/index.js": 9495,
	"./FoodTruckPosRedirect.js": 7089,
	"./ForgotPasswordRedirect.js": 5362,
	"./HomePage/BannerSection.js": 7553,
	"./HomePage/BlogSection.js": 1531,
	"./HomePage/ClientsSection.js": 1955,
	"./HomePage/CountersSection.js": 3757,
	"./HomePage/FeaturesSection.js": 6192,
	"./HomePage/HowItWorksSection.js": 827,
	"./HomePage/ProductsOverviewSection.js": 6663,
	"./HomePage/QuestionsSection.js": 7425,
	"./HomePage/ReviewsSection.js": 7227,
	"./HomePage/ScreenshotsSection.js": 2280,
	"./HomePage/SpecialitiesSection.js": 4178,
	"./HomePage/WhyUseWaiterioSection.js": 6751,
	"./HomePage/index.js": 3574,
	"./HomeRedirect.js": 2534,
	"./MenuWithQRCodePage/AdvantagesSection.js": 5602,
	"./MenuWithQRCodePage/BannerSection.js": 2712,
	"./MenuWithQRCodePage/CallToActionSection.js": 6442,
	"./MenuWithQRCodePage/HowItWorksSection.js": 3325,
	"./MenuWithQRCodePage/RestaurantManagementOverviewSection.js": 5569,
	"./MenuWithQRCodePage/index.js": 4294,
	"./MenuWithQRCodePageRedirect.js": 5877,
	"./NotFoundPage.js": 7297,
	"./OnlineOrderingPage/BannerSection.js": 883,
	"./OnlineOrderingPage/FeaturesSection.js": 4722,
	"./OnlineOrderingPage/IncreaseYourProfitsSection.js": 9327,
	"./OnlineOrderingPage/OverviewSection.js": 6042,
	"./OnlineOrderingPage/PosOverviewSection.js": 3632,
	"./OnlineOrderingPage/index.js": 4781,
	"./OnlineOrderingRedirect.js": 7731,
	"./PaymentPage.js": 175,
	"./PosSystemPage/AcceptAllPaymentMethodsSection.js": 1566,
	"./PosSystemPage/BannerSection.js": 4685,
	"./PosSystemPage/ClientsSection.js": 1605,
	"./PosSystemPage/FeaturesSection.js": 6805,
	"./PosSystemPage/HardwareSection.js": 7004,
	"./PosSystemPage/HowItWorksSection.js": 4640,
	"./PosSystemPage/OnlineOrderingOverviewSection.js": 3436,
	"./PosSystemPage/QuestionsSection.js": 1912,
	"./PosSystemPage/ScreenshotsSection.js": 1489,
	"./PosSystemPage/WhyUseWaiterioSection.js": 7864,
	"./PosSystemPage/index.js": 1044,
	"./PosSystemRedirect.js": 8730,
	"./PricingPage.js": 3484,
	"./PricingRedirect.js": 3838,
	"./PricingSection.js": 4327,
	"./PrivacyPolicyPage.js": 8555,
	"./PrivacyPolicyRedirect.js": 2525,
	"./ReferallRedirect.js": 9168,
	"./ReferralPage/CommissionsSection.js": 9357,
	"./ReferralPage/index.js": 1135,
	"./TermsAndConditionsPage.js": 3173,
	"./TermsAndConditionsRedirect.js": 8062,
	"./WebsiteBuildeRedirect.js": 7398,
	"./WebsiteBuilderPage/BannerSection.js": 7183,
	"./WebsiteBuilderPage/ClientsSection.js": 4801,
	"./WebsiteBuilderPage/HowItWorksSection.js": 6169,
	"./WebsiteBuilderPage/MoreOnlineOrderingFeaturesSection.js": 6566,
	"./WebsiteBuilderPage/OnlineOrderingSection.js": 3445,
	"./WebsiteBuilderPage/POSIntegrationSection.js": 232,
	"./WebsiteBuilderPage/UsefulFeaturesSection.js": 6010,
	"./WebsiteBuilderPage/WhyUseWebsiteBuilderSection.js": 2905,
	"./WebsiteBuilderPage/index.js": 9245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5464;